import type { Attendant } from "@/interfaces/attendant";
import { httpClient } from "@/lib/api";


export type ListAttendantResponse = {
  attendants: Attendant[];
};

export type CurrentAttendantResponse = {
  userId: string
  role: 'OWNER' | 'MANAGER' | 'ATTENDANT'
  departments: Array<{ id: number; name: string }>
}

type CreatePayload = {
  name: string;
  email: string;
  phone?: string;
  departmentIds: number[];
};

export class AttendantService {

  public static async list() {
    const { data } = await httpClient().get<ListAttendantResponse>("/attendant");
    return data;
  };

  public static async get(id: number) {
    const { data } = await httpClient().get<Attendant>(`/attendant/${id}`);
    return data;
  };

  public static async me() {
    const { data } = await httpClient().get<CurrentAttendantResponse>(`/attendant/me`);
    return data;
  };

  public static async create(payload: CreatePayload) {
    const { data } = await httpClient().post<Attendant>("/attendant", payload);
    return data;
  };

  public static async update(id: number, payload: CreatePayload) {
    const { data } = await httpClient().patch<Attendant>(`/attendant/${id}`, payload);
    return data;
  }

  public static async changeDepartment(id: number, departmentId: number) {
    const { data } = await httpClient().patch(`/attendant/${id}/department/${departmentId}`);
    return data;
  }

  public static async delete(id: number) {
    const { data } = await httpClient().delete(`/attendant/${id}`);
    return data;
  }

  public static async promote(id: number) {
    const { data } = await httpClient().patch<Attendant>(`/attendant/${id}/promote`);
    return data;
  }

  public static async demote(id: number) {
    const { data } = await httpClient().patch<Attendant>(`/attendant/${id}/demote`);
    return data;
  }
}
